import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** アカウント状態 */
enum AccountStatus {
  usually = '1',
  adminLock = '2',
}

const nameConfig = {
  usually: new Map([
    [Locale.ja, '通常'],
    [Locale.en, 'Normal'],
  ]),
  adminLock: new Map([
    [Locale.ja, '管理者ロック'],
    [Locale.en, 'Administrator lock'],
  ]),
};

const toEnum = rawValueToEnum(AccountStatus, AccountStatus.usually);
const toDisplay = enumToName(AccountStatus, nameConfig);
const toDisplayWithPrefix = enumToName(AccountStatus, nameConfig, { prefix: true });

export const accountStatus = {
  enum: AccountStatus,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
  toEnum,
};
export type { AccountStatus };
